import { isFetchCollectionResultSuccessful } from '@/entities/FetchResult'
import { ClockedInTrack } from '@/entities/Track/Track'
import { getClockedInTracksV3ApiCall } from '@/entities/Track/TrackService'
import { transformClockedInTrackV3ToClockedInTrack } from '@/entities/Track/TrackTransformers'
import { TimerUser } from '@/entities/User/User'
import { reportError, reportMessage } from '@/helpers/errorReporting'

export const fetchClockedInTracks = async (users: TimerUser[]): Promise<ClockedInTrack[]> => {
    try {
        const response = await getClockedInTracksV3ApiCall()

        if (! isFetchCollectionResultSuccessful(response)) {
            reportMessage('fetchClockedInTracks', `fetchClockedInTracks failed with status code ${response.status}`)

            throw new Error(`[fetchClockedInTracksHelper]: ${response.error}`)
        }

        response.data.forEach(clockedInTrackV3 => {
            if (! users.some(user => user.id === clockedInTrackV3.userId)) {
                console.error(`Clocked in track user with id ${clockedInTrackV3.userId} is not found in users store.`)
            }
        })

        const clockedInTracks = response.data.flatMap(clockedInTrackV3 => {
            const user = users.find(storedUser => storedUser.id === clockedInTrackV3.userId)

            return user ? [transformClockedInTrackV3ToClockedInTrack(clockedInTrackV3, user.employeeNumber)] : []
        })

        if (process.env.REACT_APP_APP_ENV !== 'production') {
            console.log('Clocked in tracks added to tracks store:')
        }

        return clockedInTracks
    } catch (error) {
        reportError('fetchClockedInTracks', error)

        throw new Error('fetchClockedInTracksHelper')
    }
}
